import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";

import workStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/workStyle.js";

const useStyles = makeStyles(workStyle);

export default function SectionWork() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem cs={12} sm={8} md={8}>
          <h2 className={classes.title} style={{fontSize:'35px'}}>BUSLOC Feature Request</h2>
          <h4 className={classes.description}>
          If you have something in mind, let us know. We will build it for you.
          </h4>
          <form id="homefeaturerequest" method="POST" 
                         action="https://formspree.io/mnqoaawq">
            <GridContainer>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Your Name" name="name"
                    id="name"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      name:"name"
                     }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Your Email"  name="email"
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      name:"email"
                     }}
                  />
                </GridItem>
                <CustomInput
                  labelText="Your Message"  name="message"
                  id="message"
                  formControlProps={{
                    fullWidth: true,
                    className: classes.textArea
                  }}
                  inputProps={{
                    multiline: true,
                    rows: 5,
                    name:"message"
                  }}
                />
                <GridItem
                  xs={12}
                  sm={4}
                  md={4}
                  className={`${classes.mrAuto} ${classes.mlAuto}`}
                >
                  <input type="hidden" name="_subject" value="Home Feature a Request" />
                  <Button type="submit" value="Send" round color="info">Send Message</Button>
                </GridItem>
              </GridContainer>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
